<template>
  <div class="loading">
    <van-loading :type="type" :color="color" size="24px">{{children}}</van-loading>
    <div class="loadingFont">{{accountFont}}</div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    type: String,
    color: String,
    children: String,
    accountFont: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loadingFont{
  margin-top: 20px;
  color: #fff;
  font-size: 12px;
}
</style>
